export const gsmCharset = new Set(
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ'
  + "ÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?"
  + '¡ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  + 'ÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyz'
  + 'äöñüà',
);

export enum KeyCode {
  Enter = 'Enter',
  Tab = 'Tab',
  Space = ' ',
  Backspace = 'Backspace',
  Delete = 'Delete',
  Escape = 'Escape',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  Home = 'Home',
  End = 'End',
}
